import { ItemViewModel1 } from "../ItemViewModel";

export class SaveFuelTypeRequest {
    public id: number;
    public name: string;
}


export class SaveGBrandRequest {
    public id: number;
    public name: string;
}

export class SaveManufacturerRequest {
    public id: number;
    public name: string;
}

export class SaveTagTypeRequest {
    public id: number;
    public name: string;
}


export class SavePackageTypeRequest {
    public id: number;
    public name: string;
}

export class SaveUnitRequest {
    public id: number;
    public name: string;
}

export class SaveColourRequest {
    public id: number;
    public name: string;
    public code: string;
}

export class SaveComplainRequest {
    public id: number;
    public name: string;
}

export class SaveVehicleStatusRequest {
    public id: number;
    public name: string;
    public description: string;
}

export class SaveCountryRequest {
    public id: number;
    public countryName: string;
    public currency: string;
    public countryCode: string;
}

export class SaveVehicleModelRequest {
    public id: number;
    public name: string;
    public fuelType: ItemViewModel1;
    public brand: ItemViewModel1;
}

export class SaveSSCategoryRequest {
    public id: number;
    public name: string;
    public itemType: ItemViewModel1;
}


export class SaveTagRequest {
    public id: number;
    public name: string;
    public tagType: ItemViewModel1;
}

export class SaveGCustomerRequest {
    public id: number;
    public accCode: string;
    public accTitle: string;
    public cpCell: string;
    public countryCode: any;
    public cpContactPerson: string;
    public cpEmail: string;
    public address: string;
    public discountValue: string;
    public accCnic: string;
    public accGst: string;
    public accBankInfo: string;
    public accBankAccNo: string;
    public isCustomer: boolean;
    public tag: ItemViewModel1;
}


export class SaveGVehicleRequest {
    public id: number;
    public uniqueId: string;
    public name: string;
    public description: string;
    public registrationNumber: string;
    public chassisNumber: string;
    public engineNumber: string;
    public bikeEnggPower: string;
    public bikeGarage: string;
    public colour: string;
    public odometer: string;
    public purchaseDate: Date | string;
    public modelYear: string;
    public brand: ItemViewModel1;
    public model: ItemViewModel1;
    public customer: ItemViewModel1;
    public customerEmail: ItemViewModel1;
    public tag: ItemViewModel1;
    public tagList: ItemViewModel1[];
    public status: ItemViewModel1;
    public driverName: string;
    public driverPhone: string;
    public customerDiscount: number;
}

export class SaveVehicleNotifyRequest {
    public id: number;
    public vehicle: ItemViewModel1;
    public lastOdometer: number;
    public currentOdometer: number;
    public customerName: string;
    public customerEmail: string;
    public driverName: string;
    public customerBrand: string;
    public driverPhone: string;
    public emailCount: Date | string;
    public status: ItemViewModel1;
    public remarks: string;
    public listOfAttachment: GVehicleNotifyAttachmentModel[];
    public file: any = [];
}

export class GVehicleNotifyAttachmentModel {
    public id: number;
    public name: string;
    public attachment: string;
    public fkVehicleNotifyId: number;
}

export class SaveItemRequest {
    public id: number;
    public code: string;
    public name: string;
    public description: string;
    public registrationNo: string;
    public salePrice: number;
    public purchasePrice: number;
    public costOfGoodSold: number;
    public ssCategory: ItemViewModel1;
    public itemType: ItemViewModel1;
    public unit: ItemViewModel1;
    public colour: ItemViewModel1;
    public isGeneric: boolean;
    public isGenericModel: boolean;
    public manufacture: ItemViewModel1;
    public currentStock: number;
    public totalCurrentStock: number;
    public minStock: number;
    public maxStock: number;
    public rackId: number;
    public gItemSupplier: GItemSupplierModel[];
    public gItemModels: GItemModelModel[];
    public gItemQRCode: GItemQRModel[];
    public file?: any;
}


export class GItemSupplierModel {
    public id: number;
    public supplier: ItemViewModel1;
    public ssItemDefining: ItemViewModel1;
    public isService: boolean;
    public isActive: boolean;
}

export class GItemModelModel {
    public id: number;
    public brand: ItemViewModel1;
    public model: ItemViewModel1;
    public ssItemDefining: ItemViewModel1;
    public isService: boolean;
    public isActive: boolean;
}

export class GItemQRModel {
    public id: number;
    public code: string;
    public ssItemDefining: ItemViewModel1;
    public isService: boolean;
    public isActive: boolean;
}

export class GModelsModel {
    public id: number;
    public name: string;
    public fuelType: ItemViewModel1;
    public brand: ItemViewModel1;
}

export class GBrandModel {
    public id: number;
    public name: string;
}


export class SaveWareHouseItemRequest {
    public id: number;
    public item: ItemViewModel1;
    public wareHouse: ItemViewModel1;
    public salePrice: number;
    public purchasePrice: number;
    public costOfGoodSold: number;
    public currentStock: number;
    public assignStock: number;
    public minStock: number;
    public maxStock: number;
    public rackId: number;
    public isLock: boolean;
    public file?: any;
}

export class SaveGItemDefinintionAttachmentRequest {
    public id?: number;
    public fkGItemDefiningId?: number;
    public type?: number;
    public itemFiles?: any = [];
    public categoryFile?: any = [];
    public isprimary?: boolean;
}


export class SavePackageRequest {
    public id: number;
    public name: string;
    public description: string;
    public packageType: ItemViewModel1;
    public partsAmount: number =0;
    public serviceAmount: number=0;
    public totalAmount: number=0;
    public discountAmount: number=0;
    public packageAmount: number=0;
    public discount: number=0;
    public isGenericModel: boolean;
    public gPackagesModel: GPackagesModelModel[];
    public gPackagesItem: GPackageItemModel[];
    public services: GPackageItemModel[];
    public spareParts: GPackageItemModel[];
}

export class GPackagesModelModel {
    public id: number;
    public brand: ItemViewModel1;
    public model: ItemViewModel1;
    public pacakage: ItemViewModel1;
    public isService: boolean;

}

export class GPackageItemModel {
    public id: number;
    public pacakage: ItemViewModel1;
    public itemType: ItemViewModel1;
    public ssItemDefining: ItemViewModel1;
    public quantity: number=0;
    public salePrice: number=0;
    public amount: number=0;
    public discountPercentage: number=0;
    public isService: boolean;
    public code: string;

    public totalAmount?: number=0;
    public discountAmmount: number=0;
    public discountAmount: number=0;
    public isInventry: boolean = false;
    public vatAmount?: number=0;
    public rate: number=0;

}

export class SaveGWarehouseRequest {
    public id: number;
    public name: string;
}

export class GetItemsByWarehouseResponse{
    public id: number;
    public item: ItemViewModel1;
    public wareHouse: ItemViewModel1;
    public salePrice: number;
    public purchasePrice: number;
    public costOfGoodSold: number;
    public currentStock: number;
    public assignStock: number;
    public minStock: number;
    public maxStock: number;
    public rackId:number;
    public isLock: boolean;
}

export class SaveItemsByWarehouseRequest{
    public id: number;
    public item: ItemViewModel1;
    public wareHouse: ItemViewModel1;
    public salePrice: number;
    public purchasePrice: number;
    public costOfGoodSold: number;
    public currentStock: number;
    public assignStock: number;
    public minStock: number;
    public maxStock: number;
    public rackId:number;
    public isLock: boolean;
    public file?:any;
}


